import React, { Component } from 'react';
import './index.css';

class Row1 extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }


  render() {
    return (
      <div className='pdf-invoice-grid-row1'>
        <div className='pdf-invoice-grid-row1-side-header'>
          <div className='pdf-invoice-grid-row1-side-header-text'>{'مشخصات فروشنده'}</div>
        </div>
        <div className='pdf-invoice-grid-row1-content'>
          <div className='pdf-invoice-grid-row1-content-wrapper'>
            <div className='pdf-invoice-grid-row1-content-cl1'>
              <div><b>نام شخص حقیقی/حقوقی</b>: شرکت پردازش اطلاعات مالی مفید </div>
              <div className='display-flex-row'>
                <div style={{ width: '220px' }}><b>نشانی کامل</b>: <b>استان</b>: تهران</div>
                <div><b>شهرستان</b>: تهران</div>
              </div>
              <div><b>نشانی</b>: تهران، بلوارآفریقا، نبش دیدار شمالی، پلاک ۵۱، طبقه ششم</div>
            </div>
            <div className='pdf-invoice-grid-row1-content-cl2'>
              <div><b>شماره اقتصادی</b>: ۱۰۱۰۴۰۵۰۹۷۸
                {/* <span>
                  <span> ۴</span><span>۱</span><span>۱</span><span>۳</span><span>۹</span><span>۶</span>
                  <span>۱</span><span>۵</span><span>۹</span><span>۳</span><span>۴</span><span>۴</span>
                </span> */}
              </div>
              <div><b>کد پستی ۱۰ رقمی</b>: ۱۵۱۸۹۴۳۳۱۷
                {/* <span> ۱</span><span>۵</span><span>۱</span><span>۸</span><span>۹</span><span>۴</span>
                <span>۳</span><span>۳</span><span>۱</span><span>۷</span> */}
              </div>
              <div><b>تلفن</b>: ۸۱۹۰۳</div>
            </div>
            <div className='pdf-invoice-grid-row1-content-cl3'>
              <div><b>شماره ملی</b>: ۱۰۱۰۴۰۵۰۹۷۸
                {/* <span> ۰</span><span>۰</span><span>۰</span><span>۰</span><span>۳</span><span>۵</span>
                <span>۴</span><span>۹</span><span>۸</span><span>۳</span> */}
              </div>
              <div><b>شهر</b>: تهران</div>
              <div><b>نمابر</b>: ۸۱۹۰۱۶۰۸</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}




export default Row1;
